if ( typeof LocalizationForm !== 'function' ) {

    class LookbookCarousel extends HTMLElement {
        constructor() {
        super();
        this._open = false;
        this._index = 0;
        this._items = [];
        this._touch = { x: 0, y: 0, t: 0, active: false };
        }

        connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.sectionEl = document.querySelector('[data-section-id="' + this.sectionId + '"][data-section-type="collection-list-grid"]');

        if (!this.sectionEl) return;

        // Build modal DOM
        this.modal = document.createElement('div');
        this.modal.className = 'lb-modal';
        this.modal.setAttribute('hidden', '');

        this.modal.innerHTML = `
        <div class="lb-dialog" role="dialog" aria-modal="true" aria-label="Lookbook gallery">
            <div class="lb-counter" aria-live="polite">
                <div class="lb-counter-inner">
                    <span data-current>1</span>/<span data-total>1</span>
                </div>
            </div>

            <div class="lb-viewport">
                <div class="lb-track" style="transform: translateX(0%);" data-track></div>
            </div>

            <button type="button" class="lb-close" data-action="close" aria-label="Close">&times;</button>
            <button type="button" class="lb-arrow lb-prev" data-action="prev" aria-label="Previous">&#10094;</button>
            <button type="button" class="lb-arrow lb-next" data-action="next" aria-label="Next">&#10095;</button>
        </div>
        `;

        this.appendChild(this.modal);

        this.track = this.modal.querySelector('[data-track]');
        this.counterCurrent = this.modal.querySelector('[data-current]');
        this.counterTotal = this.modal.querySelector('[data-total]');
        this.prevBtn = this.modal.querySelector('[data-action="prev"]');
        this.nextBtn = this.modal.querySelector('[data-action="next"]');

        const list = this.sectionEl.querySelector('.collection-list-grid__collections');
        this._items = Array.from(list.querySelectorAll('.collection-item'));
        this._items.forEach((el, i) => {
            if (!el.dataset.lookbookIndex) el.dataset.lookbookIndex = String(i);
            if (!el.dataset.sectionId) el.dataset.sectionId = this.sectionId;

            const openTarget = el.querySelector('[data-open-lookbook]') || el;
            openTarget.style.cursor = 'pointer';
            openTarget.addEventListener('click', (ev) => {
            ev.preventDefault();
            this.open(i);
            });

            el.addEventListener('keydown', (ev) => {
            if (ev.key === 'Enter' || ev.key === ' ') {
                ev.preventDefault();
                this.open(i);
            }
            });
        });

        this._buildSlides();

        this.modal.addEventListener('click', (ev) => {
            const label = ev.target.closest('.lookbook-item__label, .collection-item__label');
            if (label) {
              ev.preventDefault();
              const srcItem = this._items[this._index];
              const products = lbReadProductsFromItem(srcItem);
              if (products && products.length && window.ShopTheLook?.open) {
                window.ShopTheLook.open(products);
              } else {
                console.warn('No products found for current lookbook item.');
              }
              return;
            }
          
            const btn = ev.target.closest('[data-action]');
            if (!btn) return;
            const action = btn.getAttribute('data-action');
            if (action === 'close') this.close();
            if (action === 'prev') this.prev();
            if (action === 'next') this.next();
        });
          
        this._onKeydown = (ev) => {
            if (!this._open) return;
            if (ev.key === 'Escape') this.close();
            else if (ev.key === 'ArrowLeft') this.prev();
            else if (ev.key === 'ArrowRight') this.next();
        };
        document.addEventListener('keydown', this._onKeydown);

        const viewport = this.modal.querySelector('.lb-viewport');
        viewport.addEventListener('touchstart', this._onTouchStart.bind(this), { passive: true });
        viewport.addEventListener('touchmove', this._onTouchMove.bind(this), { passive: true });
        viewport.addEventListener('touchend', this._onTouchEnd.bind(this));
        this.counterTotal.textContent = String(this._items.length);
        this._updateArrows();
        }

        disconnectedCallback() {
        document.removeEventListener('keydown', this._onKeydown);
        }

        _buildSlides() {
            this.track.innerHTML = '';
          
            this._items.forEach((srcItem) => {
              const slide = document.createElement('div');
              slide.className = 'lb-slide';
          
              const inner = document.createElement('div');
              inner.className = 'lb-slide-inner';

              const srcWrapper = srcItem.querySelector('.collection-item__image-wrapper') || srcItem;
              const clone = srcWrapper.cloneNode(true);
          
              clone.querySelectorAll('[data-open-lookbook]').forEach((el) => {
                el.removeAttribute('data-open-lookbook');
              });
          
              const hasLabel = !!clone.querySelector('.lookbook-item__label');
              if (!hasLabel) {
                const srcLabel = srcItem.querySelector('.lookbook-item__label');
                if (srcLabel) {
                  clone.appendChild(srcLabel.cloneNode(true));
                }
              }
          
              clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
          
              clone.querySelectorAll('a').forEach((a) => {
                a.setAttribute('tabindex', '-1');
                a.addEventListener('click', (e) => e.preventDefault());
              });
          
              inner.appendChild(clone);
              slide.appendChild(inner);
              this.track.appendChild(slide);
            });
        }

        _openShopTheLook() {
            const i = this._index;
            const srcItem = this._items[i];
            if (!srcItem || !window.ShopTheLook) return;
          
            const products = lbReadProductsFromItem(srcItem);
            window.ShopTheLook.open(products);
        }

        open(index) {
        if (index < 0 || index >= this._items.length) index = 0;
        this._open = true;
        this.modal.removeAttribute('hidden');
        document.documentElement.classList.add('lb-nosrcoll');
        this.goTo(index);
        const closeBtn = this.modal.querySelector('.lb-close');
        if (closeBtn) closeBtn.focus({ preventScroll: true });
        }

        close() {
        this._open = false;
        this.modal.setAttribute('hidden', '');
        document.documentElement.classList.remove('lb-nosrcoll');
        }

        next() {
        this.goTo((this._index + 1) % this._items.length);
        }

        prev() {
        this.goTo((this._index - 1 + this._items.length) % this._items.length);
        }

        goTo(index) {
        this._index = index;
        this.track.style.transform = 'translateX(' + (-100 * index) + '%)';
        this.counterCurrent.textContent = String(index + 1);
        this._updateArrows();
        }

        _updateArrows() {
        this.prevBtn.disabled = false;
        this.nextBtn.disabled = false;
        }

        _onTouchStart(ev) {
        const t = ev.changedTouches[0];
        this._touch = { x: t.clientX, y: t.clientY, t: Date.now(), active: true };
        }
        _onTouchMove(ev) {
        }
        _onTouchEnd(ev) {
        if (!this._touch.active) return;
        const t = ev.changedTouches[0];
        const dx = t.clientX - this._touch.x;
        const dy = t.clientY - this._touch.y;
        const dt = Date.now() - this._touch.t;

        const horiz = Math.abs(dx) > Math.abs(dy);
        const fastEnough = dt < 600;
        const farEnough = Math.abs(dx) > 50;

        if (horiz && fastEnough && farEnough) {
            if (dx < 0) this.next();
            else this.prev();
        }

        this._touch.active = false;
        }
    }

    if ( typeof customElements.get('lookbook-carousel') == 'undefined' ) {
    customElements.define('lookbook-carousel', LookbookCarousel);
    }
}